'use client';

import { useCallback, useRef } from 'react';
import type { OzonetelCallStatus } from '../../consts/ozonetel/sdk';

export function useOzonetelCallStatus() {
  const callStatusRef = useRef<OzonetelCallStatus>('UNAUTHORIZED');
  const isInitializedRef = useRef(false);

  const setCallStatus = useCallback((nextStatus: OzonetelCallStatus) => {
    callStatusRef.current = nextStatus;
  }, []);

  return { callStatusRef, isInitializedRef, setCallStatus } as const;
}
